import { render, staticRenderFns } from "./TheBreadcrumb.vue?vue&type=template&id=67e5f90b"
import script from "./TheBreadcrumb.vue?vue&type=script&lang=js"
export * from "./TheBreadcrumb.vue?vue&type=script&lang=js"
import style0 from "./TheBreadcrumb.vue?vue&type=style&index=0&id=67e5f90b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports